var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDbxen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216.563,
    height: 55.495,
    viewBox: "0 0 216.563 55.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17019",
    "data-name": "Rectangle 17019",
    width: 216.563,
    height: 55.495,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M.5,54.494A.441.441,0,0,1,0,54V.5A.441.441,0,0,1,.5,0H14.477Q26.79,0,32.906,5.782t6.115,17.763V29.95q0,12.563-6.115,18.554t-18.429,5.99Zm3.162-3.245h10.65q10.647,0,15.849-5.116t5.2-16.016V23.378q0-10.4-5.2-15.266T14.312,3.243H3.661Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M44.667,54.5a.442.442,0,0,1-.5-.5V.5a.442.442,0,0,1,.5-.5h14.31q8.987,0,13.4,3.328T76.782,13.4a12.761,12.761,0,0,1-2.371,7.944,13.906,13.906,0,0,1-7.364,4.617v.084a16.11,16.11,0,0,1,8.985,4.284q3.247,3.289,3.245,9.11,0,7.738-4.784,11.4T59.143,54.5Zm3.162-29.7H60.474q5.989,0,9.318-2.953a10.188,10.188,0,0,0,3.328-8.029q0-5.573-3.535-8.07t-11.107-2.5H47.828Zm0,26.374H59.06q8.9,0,12.729-2.829t3.829-9.069q0-5.657-3.953-8.527T60.641,27.871H47.828Z",
    transform: "translate(8.746 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M77.982,54.494q-.332,0-.374-.165a.754.754,0,0,1,.041-.417L96.868,26.456,78.814.582c-.165-.168-.208-.3-.125-.417A.444.444,0,0,1,79.064,0h3.328a.645.645,0,0,1,.581.249l11.4,16.306q1.163,1.747,2.455,3.578t2.455,3.577h.081q1.249-1.829,2.539-3.661t2.537-3.66L115.672.249A.644.644,0,0,1,116.254,0H119.5c.22,0,.346.056.374.165a.766.766,0,0,1-.041.417L101.693,26.54l19.136,27.372a.418.418,0,0,1,.083.417c-.056.11-.194.165-.415.165h-3.329a.8.8,0,0,1-.582-.249L105.521,38.269q-1.583-2.244-3.162-4.493t-3.078-4.493H99.2q-1.5,2.165-3.037,4.368T93.125,38.02L81.81,54.161a.536.536,0,0,1-.5.333Z",
    transform: "translate(15.365 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M133.31,53.278q-7.655.083-11.731-3.7T117.5,38.636V26.9q0-7.738,3.994-11.731t11.564-3.993q7.738,0,11.648,3.951t3.91,11.524V31.98a.442.442,0,0,1-.5.5H121.163v5.159q0,6.157,3.037,9.234t9.276,3.078q5.242,0,7.946-2.038a6.729,6.729,0,0,0,2.7-5.7.442.442,0,0,1,.5-.5h2.662c.333,0,.5.14.5.417a9.293,9.293,0,0,1-3.619,8.153q-3.786,2.913-10.858,3M121.163,29.235h23.795V26.989q0-6.241-3-9.361t-8.817-3.118q-5.991,0-8.986,3.162t-3,9.318Z",
    transform: "translate(23.267 2.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M183.163,14.509q-2.954-3.328-8.693-3.328a16.5,16.5,0,0,0-5.866,1.082,23.117,23.117,0,0,0-5.7,3.2,44.456,44.456,0,0,0-5.024,4.47c-.013-.586-.018-1.161-.05-1.766q-.083-1.5-.207-2.954t-.292-2.537c-.056-.333-.222-.5-.5-.5h-2.579c-.333,0-.5.2-.5.583q.167,1.914.333,4.367t.167,4.618V51.782a.441.441,0,0,0,.5.5h2.663a.441.441,0,0,0,.5-.5V23.541A41.831,41.831,0,0,1,165.651,17a15.211,15.211,0,0,1,8.154-2.5q4.41,0,6.53,2.579t2.122,8.07V51.782a.442.442,0,0,0,.5.5h2.662a.441.441,0,0,0,.5-.5V24.825q0-6.989-2.953-10.316",
    transform: "translate(30.446 2.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M20.272,23.309a3.422,3.422,0,1,1-3.422-3.422,3.422,3.422,0,0,1,3.422,3.422",
    transform: "translate(2.659 3.938)",
    fill: "#f5b700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbxen);
export default __webpack_public_path__ + "static/media/dbxen.ad029e23cb4cbed0e40edd040ff78fdc.svg";
export { ForwardRef as ReactComponent };